import React from 'react'
import styled, { css } from 'styled-components'
import Box from '@components/Box'
import { STypographyDefault } from '@components/Typography'
import { above, below } from '@styles/mixins/breakpoints'
import { TBenefit } from '@api/Form'

export type ICard = Partial<TBenefit>

const SCard = styled(Box)`
  height: 180px;
  max-width: 300px;
  width: 100%;
  padding-left: 20px;
  flex-shrink: 0;
  flex-grow: 0;

  ${below(1200)(css`
    max-width: calc((100% - 24%) / 2);
  `)}

  ${below('md')(css`
    max-width: 100%;
    width: calc(100%);
  `)}
`

const SIcon = styled(Box)`
  padding: 4px;
  background: #f0f3f6;
  border-radius: 12px;
`

const SContainer = styled(Box)`
  position: relative;
  border: 1px solid #e2e6ec;
  border-radius: 8px;
  padding: 24px;
  height: 100%;
`
const SBigNumber = styled(STypographyDefault)`
  color: ${({ theme }) => theme.colors.green};
  font-size: 36px;
  line-height: 44px;

  font-weight: 600;
  width: 100%;

  ${above('md')(css`
    font-size: 40px;
    line-height: 48px;
  `)}
`

const Card: React.FC<ICard> = ({ description, subtitle, mark, icon }) => {
  return (
    <SCard>
      <SContainer display="flex" flexDirection="column" alignItems="flex-start" height="100%">
        <Box width="100%" display="flex" justifyContent="space-between" alignItems="flex-start">
          <Box>
            <STypographyDefault width="100%" mb={'8px'}>
              {subtitle}
            </STypographyDefault>
            <SBigNumber>{mark}</SBigNumber>
          </Box>
          {icon && (
            <SIcon>
              <img src={icon} alt="icon" />
            </SIcon>
          )}
        </Box>
        <STypographyDefault width="100%">{description}</STypographyDefault>
      </SContainer>
    </SCard>
  )
}

export default Card
